import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const DAILY_GOAL_CONFIG = enabledOn(PlatformSlug.CARSBooster)

export const isDailyGoalAvailable = (slug?: PlatformSlug) => isFeatureAvailable(DAILY_GOAL_CONFIG, slug)
